// import { getDictCodes } from '@/api/system/dict';
import { getMemberList } from '@/api/member/personal';

const state = {
  memberList: [],
  total: 0
};

const mutations = {
  GET_MEMBER_LIST: (state, list) => {
    state.memberList = list;
  },
  UPDATE_TOTAL: (state, total) => {
    state.total = total;
  }
};

const actions = {
  getMemberList({ commit }, query) {
    return getMemberList(query).then(response => {
      const res = response.data;
      if (res.code === 200) {
        commit('GET_MEMBER_LIST', res.data.records);
        commit('UPDATE_TOTAL', res.data.total);
      }
    })
  }

};

const getters = {
  memberList: state => state.memberList,
  total: state => state.total
};

export default { state, mutations, actions, getters, namespaced: true };
